/**
 * The non-component half of SymbolLink, kept apart so the component file
 * exports only components (react-refresh).
 */

/** For the one child of a `underline="group"` SymbolLink that should underline. */
export const SYMBOL_LINK_HOVER =
  'underline-offset-2 group-hover/symbol:underline group-focus-visible/symbol:underline'

/**
 * DataTable `rowLinkOptions` for a row that is about one stock: the whole row
 * becomes one real `<a>` to the company page. `as const` keeps `to` a literal
 * so DataTable infers its `TTo` and checks `params` against the route.
 */
export const stockLinkOptions = (symbol: string) => ({
  to: '/stocks/$symbol' as const,
  params: { symbol },
})
